import type { ThemeManifest } from '../types';
import { Layout } from './Layout';
import { DashboardLayout } from './DashboardLayout';
import { PageHeader } from './PageHeader';

export const lightspeedTheme: ThemeManifest = {
  preset: 'lightspeed',
  displayName: 'Lightspeed',
  description:
    'Lightspeed Retail X-Series look — horizontal top navigation with breadcrumbs, teal accent, dense layouts, squarer corners.',
  className: 'theme-lightspeed',
  components: {
    Layout,
    DashboardLayout,
    PageHeader,
  },
};
